<template>
  <div class="device-detail-bd" v-if="funcView.device_detail">
    <!-- {{deviceInfo}} -->
    <div class="page-content clear">
      <div class="device-param">
        <div class="header">
          <div class="device-sn">{{ deviceInfo.productName }}</div>
          <div class="device-state" v-if="type !== 'return' && maintainStatus && maintainStatus[0]">
            <!-- {{ maintainStatus}} -->
            <!-- <div class="device-state-tag" v-for="(item, index) in statusList" :key="index" :class="{ 'has-name': item.name }">
              <i :class="item.className"></i>
              <span class="state-name">{{ item.name }}</span>
            </div> -->
            <i class="point" :class="maintainStatus[0].className"></i>
            <span class="state-name" :class="maintainStatus[0].className">{{ maintainStatus[0].name || '-' }}</span>
          </div>
        </div>
        <div class="device-img" :class="{ gray: !curProductImg, offline: !deviceInfo.isOnline }">
          <img :src="curProductImg" alt v-if="curProductImg" />
        </div>
        <p class="body-num">{{ deviceInfo.bodyNum }}</p>
        <div class="device-status-container" v-if="type !== 'return' &&deviceInfo.isOnline">
          <ul class="device-status">
            <li class="battery" v-if="deviceInfo.batteryCharge || deviceInfo.batteryCharge === 0">
              <div class="key">
                <icon type="battery" :value="deviceInfo.batteryCharge"></icon>
              </div>
              <div class="val">{{ deviceInfo.batteryCharge || deviceInfo.batteryCharge === 0 ? deviceInfo.batteryCharge : '-' }}%</div>
            </li>
            <li class="signal" v-if="(`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1') || (`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1')">
              <div class="key">
                <!--
                  deviceInfo.cellularMode
                    1-WIFI
                    2-2G
                    3-3G
                    4-4G
                 -->
                <i v-if="`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1'" class="icon-wifi-i" :class="wifi(deviceInfo.signal)"></i>
                <i v-else-if="`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1'" class="icon-signal-i" :class="signal(deviceInfo.signal)"></i>
              </div>
              <!--
                networkType 和 cellularMode都为1显示
                networkType 0和cellularMode不为1显示
                其余不显示
              -->
              <div class="val" v-if="(`${deviceInfo.networkType}` === '1' && `${deviceInfo.cellularMode}` === '1') || (`${deviceInfo.networkType}` === '0' && `${deviceInfo.cellularMode}` !== '1')">
                {{ getDicValue('dms_device_cellular_mode', deviceInfo.cellularMode) || '-' }}
              </div>
              <!-- <div class="val">{{ deviceInfo.networkType ? getDicValue('dms_device_network_type', deviceInfo.networkType): '-' }}</div> -->
            </li>
            <li class="temperature" v-if="deviceInfo.batteryTemp || deviceInfo.batteryTemp === 0">
              <div class="key">
                <!-- <i type="temperature" :value="deviceInfo.batteryTemp"></i> -->
                <icon type="temperature" :value="deviceInfo.batteryTemp"></icon>
              </div>
              <div class="val">{{ $celsiusToFahrenheit(deviceInfo.batteryTemp) || '-'}}{{$formatTempUnit()}}</div>
            </li>
          </ul>
          <div class="device-state">
            <!-- {{statusList(item)}} -->
            <div class="device-state-tag" v-for="(icon, index) in statusList" :key="index" :class="{ 'has-name': icon.name }">
              <i :class="icon.className"></i>
              <!-- <span class="state-name">{{ item.name }}</span> -->
            </div>
          </div>
        </div>
        <ul class="param-detail">
          <li v-if="type !== 'return'&&!!deviceInfo.hmiMalfunction&&funcView.portal_device_fault">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_gzxq') }}
              </div>
            </div>
            <i class="icon icon-you" @click="onFaultDetails"></i>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('device_detail_ming_cheng') }}
              </div>
              <div class="val">{{ deviceInfo.deviceName || '-' }}</div>
            </div>
            <i class="icon icon-bianji" @click="changeDeciceName" v-if="type !== 'return' &&funcView.device_change_name"></i>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('device_detail_xiang_mu') }}
              </div>
              <div class="val ">{{ deviceInfo.locationName || '-' }}</div>
            </div>
            <i class="icon icon-bianji" @click="onMoveDevice()"  v-if="type !== 'return' &&funcView.device_change_location"></i>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('device_detail_qu_yu') }}
              </div>
              <div class="val">{{ deviceInfo.siteName || '-' }}</div>
            </div>
            <i class="icon icon-bianji" @click="onMoveDevice()"  v-if="type !== 'return' &&funcView.device_change_area"></i>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('device_detail_bu_men') }}
              </div>
              <div class="val">{{ deviceInfo.departmentName || '-' }}</div>
            </div>
          </li>
          <li>
            <div class="content">
              <div class="key">
                {{ $t('device_detail_fu_zhai_ren') }}
              </div>
              <div class="val">{{ deviceInfo.projectContactName || '-' }} {{deviceInfo.projectContactPhone}}</div>
            </div>
            <i class="icon icon-bianji" @click="changeProjectName()"  v-if="type !== 'return' &&funcView.device_change_person"></i>
          </li>
          <li v-if="type !== 'return'">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_wei_zhi') }}
              </div>
              <div class="val">{{ deviceInfo.gpsAddress || '-' }}</div>
            </div>
            <i v-if="deviceInfo.gpsAddress && type !== 'return'" class="icon icon-you" @click="jumpLocation"></i>
          </li>
          <li v-if="type !== 'return'">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_zhzxsj') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.lastOnlineTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="type !== 'return'">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_zhqjsj') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.lastCleanStartTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="type === 'return'">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_qi_zu_ri_qi') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.rentalStartTime) || '-') }}</div>
            </div>
          </li>
          <li v-if="type === 'return'">
            <div class="content">
              <div class="key">
                {{ $t('device_detail_dao_qi_ri_qi') }}
              </div>
              <div class="val">{{ momentAmPm($momentLocal(deviceInfo.unbindOrgTime) || '-') }}</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="tap-content">
        <div class="tab-box">
          <el-tabs v-model="tabIndex" v-if="tabData.length">
            <el-tab-pane v-for="item in tabData" :label="item.name" :name="item.value" :key="item.value"></el-tab-pane>
          </el-tabs>
        </div>
        <day
          v-if="tabIndex === 'day'"
          :deviceInfo="deviceInfo"
          :tabData="typeData"
          :isCharging="isCharging"
          :isManual="isManual"
          :isAutonomous="isAutonomous"
          :isTraining="isTraining"
          :productClass="productClass"
        ></day>
        <!-- && `${productClass}` ==='1' -->
        <sheet-history-traditional
          v-if="tabIndex === 'sheet'"
          :deviceInfo="deviceInfo"
          :tabData="typeData"
          :isCharging="isCharging"
          :isManual="isManual"
          :isAutonomous="isAutonomous"
          :isTraining="isTraining"
          :productClass="productClass"
        ></sheet-history-traditional>
        <!-- ice使用历史 -->
        <history-traditional
          v-if="tabIndex === 'history'"
          :deviceInfo="deviceInfo"
          :tabData="typeData"
          :isCharging="isCharging"
          :isManual="isManual"
          :isAutonomous="isAutonomous"
          :isTraining="isTraining"
          :productClass="productClass"
        ></history-traditional>
        <!--开机卡 -->
        <open-card v-if="tabIndex === 'openCard'" :deviceInfo="deviceInfo" :productClass="productClass"></open-card>
        <!-- 密码卡 -->
        <password-card v-if="tabIndex === 'passwordCard'" :deviceInfo="deviceInfo" :productClass="productClass"></password-card>
        <!-- 保养 -->
        <maintain v-if="tabIndex === 'maintain'" :deviceInfo="deviceInfo" :productClass="productClass"></maintain>
        <!-- 路线管理 -->
        <device-detail-route v-if="tabIndex === 'route'" :deviceInfo="deviceInfo" :productClass="productClass"></device-detail-route>
      </div>
    </div>
    <!-- 转移 -->
    <location-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getDeviceInfo()"></location-device-dialog>
    <!-- 修改设备名称 -->
    <device-rename-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getDeviceInfo()"></device-rename-dialog>
    <!-- 修改项目负责人 -->
    <device-projectName-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getDeviceInfo()"></device-projectName-dialog>
    <!-- 故障详情 -->
    <device-fault-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"></device-fault-dialog>
  </div>
</template>

<script>
// import moment from 'moment';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import icon from '@/components/icon.vue';
import day from './children/device_detail_sheet_day.vue';
import sheetHistoryTraditional from './children/device_detail_sheet_history_traditional.vue';
import historyTraditional from './children/device_detail_history_traditional.vue';
import openCard from './children/device_detail_open_card.vue';
import passwordCard from './children/device_detail_password_card.vue';
import maintain from './children/device_detail_maintain.vue';
import locationDeviceDialog from '../distribution/children/location_device_dialog.vue';
import deviceRenameDialog from './children/device_rename_dialog.vue';
import deviceProjectNameDialog from './children/device_projectName_dialog.vue';
import deviceDetailRoute from './children/device_detail_route.vue';
import deviceFaultDialog from './children/device_fault_dialog.vue';

// i18n-lang-component
// device_detail_gzxq: 故障详情// device_detail_ming_cheng: 名称// device_detail_xiang_mu: 项目// device_detail_qu_yu: 区域// device_detail_bu_men: 部门// device_detail_fu_zhai_ren: 负责人// device_detail_wei_zhi: 位置// device_detail_zhzxsj: 最后在线时间// device_detail_zhqjsj: 最后清洁时间// device_detail_qi_zu_ri_qi: 启租日期// device_detail_dao_qi_ri_qi: 到期日期// device_detail_yun_xing_zhong: 运行中// device_detail_chong_dian_zhong: 充电中// device_detail_sgqj: 手工清洁// device_detail_zhi_neng: 智能// device_detail_jiao_xue: 教学// device_detail_chong_dian: 充电// device_detail_sysct: 使用时长(天)// device_detail_nybb: 年月报表// device_detail_shi_yong_ji_lu: 使用记录// device_detail_kai_ji_ka_xin_xi: 开机卡信息// device_detail_kjmmxx: 开机密码信息// device_detail_bao_yang_ji_lu: 保养记录// device_detail_sysct_1: 使用时长(天)// device_detail_nybb_1: 年月报表// device_detail_shi_yong_ji_lu_1: 使用记录// device_detail_bao_yang_ji_lu_1: 保养记录// device_detail_lu_xian_guan_li: 路线管理// device_detail_ggxmqy: 更改项目/区域// device_detail_xgsbmc: 修改设备名称// device_detail_xgfzr: 修改负责人// device_detail_gzxq_1: 故障详情

export default {
  name: 'devicedetail',
  components: {
    icon,
    locationDeviceDialog,
    day,
    sheetHistoryTraditional,
    historyTraditional,
    openCard,
    passwordCard,
    maintain,
    deviceFaultDialog,
    deviceRenameDialog,
    deviceProjectNameDialog,
    deviceDetailRoute
  },
  computed: {
    curProductImg() {
      if (this.imgList.length) {
        return this.imgList[0].url;
      }
      return '';
    },
    // 设备状态icon列表
    statusList() {
      if (this.deviceInfo && Object.keys(this.deviceInfo).length) {
        const ret = [];
        const { lockState, isOnline, isPowerSave } = this.deviceInfo;
        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          // 显示锁机(自由锁1 账单锁2)
          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-locking gray',
              dicCode: 'isLock'
            });
          }
          // 故障
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault'
          //   });
          // }
          // 是否省电模式
          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave'
            });
          }
        } else {
          // 设备多状态：可以同时存在多个的状态
          /** 设备多状态 start */

          if (lockState) {
            ret.push({
              type: 'lock',
              value: lockState,
              className: 'icon icon-suoji gray',
              dicCode: 'isLock'
            });
          }
          // if (isMalfunction) {
          //   ret.push({
          //     type: 'malfunction',
          //     value: isMalfunction,
          //     className: 'icon icon-guzhang red',
          //     dicCode: 'isFault'
          //   });
          // }

          if (isPowerSave) {
            ret.push({
              type: 'power',
              value: isPowerSave,
              className: 'icon icon-jieneng green',
              dicCode: 'isPowerSave'
            });
          }
          /** 设备多状态 end */
        }
        return ret;
      }
      return [];
    },
    maintainStatus() {
      if (Object.keys(this.deviceInfo).length) {
        const ret = [];
        // 设备唯一状态
        const machineStatusList = [
          // 空闲
          {
            type: 'free',
            value: '1',
            className: 'icon-free blue',
            name: this.getDicValue('machine_state', '1')
          },
          // 手工清洁
          {
            type: 'handCleaning',
            value: '2',
            className: 'icon-cleaning green',
            name: this.getDicValue('machine_state', '2')
          },
          // 教学
          {
            type: 'teach',
            value: '3',
            className: 'icon-cleaning green',
            name: this.getDicValue('machine_state', '3')
          },
          // 智能清洁
          {
            type: 'intelligentCleaning',
            value: '4',
            className: 'icon-cleaning green',
            name: this.getDicValue('machine_state', '4')
          },
          // 协助
          {
            type: 'assist',
            value: '5',
            className: 'icon-assist red',
            name: this.getDicValue('machine_state', '5')
          },
          // 暂停
          {
            type: 'stop',
            value: '6',
            className: 'icon-suspend green',
            name: this.getDicValue('machine_state', '6')
          }
        ];
        const { isCharging, isOnline, isRunning, machineState } = this.deviceInfo;

        // 如果是离线状态，不显示其他实时状态(只有锁机 故障 省电)
        if (!isOnline) {
          ret.push({
            type: 'online',
            value: isOnline,
            className: 'icon-machine-offline gray',
            dicCode: 'isOffline',
            name: this.getDicValue('cloud_common_online', isOnline)
          });
        } else {
          // 设备多状态：可以同时存在多个的状态
          /** 设备多状态 start */

          if (isRunning) {
            ret.push({
              type: 'running',
              value: isRunning,
              className: 'icon-using green',
              dicCode: this.$t('device_detail_yun_xing_zhong')
            });
          }
          if (isCharging) {
            ret.push({
              type: 'charge',
              value: isCharging,
              className: 'icon-charge yellow',
              dicCode: 'isCharging',
              name: this.$t('device_detail_chong_dian_zhong')
            });
          }
          // else {
          //   ret.push({
          //     type: 'running',
          //     value: isRunning,
          //     className: 'icon icon-suspend blue',
          //     dicCode: 'isOnline'
          //   });
          // }

          // if (this.ret.some(item => item.type === 'lock')) {

          // }

          // 设备唯一状态：同时只能出现一种的

          // 如果出现了充电中 机器状态就替换成充电中
          // if (isCharging && machineState !== '1') {
          //   if (obj) {
          //     ret.push(obj);
          //   }
          // } else
          if (!isCharging && machineState !== '1') {
            const obj = machineStatusList.find(item => item.value === `${machineState}`);
            if (obj) {
              ret.push(obj);
            }
          }
          /** 设备多状态 end */
        }
        return ret;
      }
      return [];
    },
    // 充电
    isCharging() {
      return this.deviceInfo && this.deviceInfo.supportFunc && this.deviceInfo.supportFunc.includes('charging');
    },
    // 手工
    isManual() {
      return this.deviceInfo && this.deviceInfo.supportFunc && this.deviceInfo.supportFunc.includes('manual');
    },
    // 自动
    isAutonomous() {
      return this.deviceInfo && this.deviceInfo.supportFunc && this.deviceInfo.supportFunc.includes('autonomous');
    },
    // 教学
    isTraining() {
      return this.deviceInfo && this.deviceInfo.supportFunc && this.deviceInfo.supportFunc.includes('training');
    },
    typeData() {
      // "1": "充电", "2": "清洁", "4": "教学", "5": "自动"
      const arr = [
        {
          name: this.$t('com_all'),
          value: '0'
        }
      ];
      if (this.isManual) {
        arr.push({
          name: this.$t('device_detail_sgqj'),
          value: '2'
        });
      }
      if (this.isAutonomous) {
        arr.push({
          name: this.$t('device_detail_zhi_neng'),
          value: '5'
        });
      }
      if (this.isTraining) {
        arr.push({
          name: this.$t('device_detail_jiao_xue'),
          value: '4'
        });
      }
      if (this.isCharging) {
        arr.push({
          name: this.$t('device_detail_chong_dian'),
          value: '1'
        });
      }
      return arr;
    }
  },
  data() {
    return {
      tabData: [],
      provide: true,
      tabIndex: '',
      deviceId: '',
      deviceInfo: {},
      workInfo: {},
      imgList: [],
      ParamGroupTree: [],

      bodyNum: '',
      productClass: '', // traditional-1-传统机  robot-2-机器人
      // protocolClass: '', // RBT ICE3 ICE4 ICER ICE4T-机器人  SBR用传统机
      siteCode: '',
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      type: ''// normal 正常  return退回
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_deviceDetail');
    this.getFuncView('/other/device', () => {
      this.initTabData();
    });
  },
  methods: {
    i18nCallback() {
      this.deviceId = this.getJump('deviceId');
      this.siteCode = Cookies.get('siteCode') || 'CN';
      this.getDeviceInfo(true);
    },
    initTabData: function () {
      if (this.type !== 'return' && `${this.productClass}` === '1') {
        const arr = [];
        if (this.funcView.device_detail_day) {
          arr.push({
            name: this.$t('device_detail_sysct'),
            value: 'day'
          });
        }
        if (this.funcView.device_detail_annual) {
          arr.push({
            name: this.$t('device_detail_nybb'),
            value: 'sheet'
          });
        }
        if (this.funcView.device_detail_record) {
          arr.push({
            name: this.$t('device_detail_shi_yong_ji_lu'),
            value: 'history'
          });
        }
        if (this.funcView.device_detail_bootCard && `${this.deviceInfo.cardClass}` === '1') {
          arr.push({
            name: this.$t('device_detail_kai_ji_ka_xin_xi'),
            value: 'openCard'
          });
        }
        if (this.funcView.device_detail_password_list && `${this.deviceInfo.cardClass}` === '2') {
          arr.push({
            name: this.$t('device_detail_kjmmxx'),
            value: 'passwordCard'
          });
        }
        if (this.funcView.device_detail_maintenance) {
          arr.push({
            name: this.$t('device_detail_bao_yang_ji_lu'),
            value: 'maintain'
          });
        }
        this.tabData = arr;

        // this.tabData = [
        //   {
        //     name: '使用时长(天)',
        //     value: 'day'
        //   },
        //   {
        //     name: '年月报表',
        //     value: 'sheet'
        //   },
        //   {
        //     name: '使用记录',
        //     value: 'history'
        //   },
        //   {
        //     name: '开机卡信息',
        //     value: 'openCard'
        //   },
        //   {
        //     name: '保养记录',
        //     value: 'maintain'
        //   }
        // ];
      } else {
        const arr = [];
        if (this.funcView.device_detail_day) {
          arr.push({
            name: this.$t('device_detail_sysct_1'),
            value: 'day'
          });
        }
        if (this.funcView.device_detail_annual) {
          arr.push({
            name: this.$t('device_detail_nybb_1'),
            value: 'sheet'
          });
        }
        if (this.funcView.device_detail_record) {
          arr.push({
            name: this.$t('device_detail_shi_yong_ji_lu_1'),
            value: 'history'
          });
        }
        if (this.funcView.device_detail_maintenance) {
          arr.push({
            name: this.$t('device_detail_bao_yang_ji_lu_1'),
            value: 'maintain'
          });
        }
        this.tabData = arr;


        // this.tabData = [
        //   {
        //     name: '使用时长(天)',
        //     value: 'day'
        //   },
        //   {
        //     name: '年月报表',
        //     value: 'sheet'
        //   },
        //   {
        //     name: '使用记录',
        //     value: 'history'
        //   },

        //   {
        //     name: '保养记录',
        //     value: 'maintain'
        //   }
        // ];
      }
      if (this.funcView.device_detail_route_manage && `${this.productClass}` === '2') {
        this.tabData.push({
          name: this.$t('device_detail_lu_xian_guan_li'),
          value: 'route'
        });
      }
      this.$nextTick(() => {
      // this.tabIndex = 'day';
        // console.log(this.tabData, this.funcView);
        this.tabIndex = this.tabData[0] && this.tabData[0].value || '';
      });

    },
    // 获取设备详情
    getDeviceInfo: function (init) {
      this.type = this.getJump('type') || 'normal';
      if (this.type === 'return') {
        this.$getJSON(apis.hisDeviceInfo, {
          bindManualId: this.deviceId
        }).then((res) => {
          this.deviceInfo = res.data;
          // this.tabIndex = 'day';
          // this.tabIndex = this.tabData && this.tabData[0].value;
          this.getImgList(this.deviceInfo.productCodeId, 'dms.product.icon');
          this.bodyNum = res.data.bodyNum;
          this.productClass = res.data.productClass;
          if (init) {
            this.initTabData();
          }
        });
      } else {
        this.$getJSON(apis.DeviceInfo, {
          deviceId: this.deviceId
        }).then((res) => {
          this.deviceInfo = res.data;
          // this.tabIndex = 'day';
          // this.tabIndex = this.tabData && this.tabData[0].value;
          this.getImgList(this.deviceInfo.productCodeId, 'dms.product.icon');
          this.bodyNum = res.data.bodyNum;
          this.productClass = res.data.productClass;
          if (init) {
            this.initTabData();
          }
        });
      }

    },
    // 获取图片列表
    getImgList(bizId, bizType) {
      this.$getFileList({ bizId, bizType }).then((list) => {
        this.imgList = list;
        this.deviceInfo.productImage = list;
      });
    },
    jumpLocation() {
      // this.jump('/other/device', {
      //   showType: 'map'
      // });

      this.jump('/other/device', {
        showType: 'map'
      });
    },
    // 转移设备
    onMoveDevice: function () {
      this.dialogModel = {
        title: this.$t('device_detail_ggxmqy'),
        orgId: this.deviceInfo.orgId,
        tableSelect: [{ ...this.deviceInfo }]
      };
      this.dialogVisible = true;
    },
    signal(val) {
      if (val >= 100) {
        return 'signal-xinhao100';
      }
      if (val >= 75) {
        return 'signal-xinhao75';
      }
      if (val >= 50) {
        return 'signal-xinhao50';
      }
      return 'signal-xinhao25';
    },
    wifi(val) {
      if (val > 80) {
        return 'wifi100';
      }
      if (val > 0 && val <= 80) {
        return 'wifi66';
      }
      return 'wifi33';
    },

    changeDeciceName: function () {
      this.dialogModel1.type = 'edit';
      this.dialogModel1.title = this.$t('device_detail_xgsbmc');
      this.dialogModel1.data = this.deviceInfo;
      this.dialogVisible1 = true;
    },
    changeProjectName: function () {
      this.dialogModel2.type = 'edit';
      this.dialogModel2.title = this.$t('device_detail_xgfzr');
      this.dialogModel2.data = this.deviceInfo;
      this.dialogVisible2 = true;
    },
    onFaultDetails: function () {
      this.dialogModel3.type = 'detail';
      this.dialogModel3.title = this.$t('device_detail_gzxq_1');
      this.dialogModel3.data = this.deviceInfo;
      this.dialogVisible3 = true;
    },
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.device-detail-bd {
  padding: 24px;

  > .header {
    padding: 24px 0 16px 0;
    height: 68px;
    overflow: hidden;
    .icon {
      font-size: 16px;
      float: left;
      line-height: 30px;
      font-weight: bold;
    }
    .title {
      float: left;
      margin-left: 18px;
      color: #394668;
      font-size: 18px;
      line-height: 32px;
      &:hover {
        cursor: pointer;
      }
    }
    .func-group {
      float: right;

      .btn-text {
        line-height: 24px;
        // padding-right: 14px;
      }

      .icon-xiala {
        color: $--color-primary;
      }

      .el-dropdown {
        float: left;
      }

      .el-button {
        float: left;
        margin-left: 8px;
      }
    }
  }
  .page-content {
    width: 100%;
    // height: calc(100% - 68px);
    // min-width: 1300px;
    .device-param {
      width: 280px;
      padding: 24px 24px 80px;
      float: left;
      margin-right: 24px;
      background: #ffffff;
      box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.019999999552965164);
      border-radius: 16px;
      .header {
        height: 20px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-content: center;
        .device-sn {
          float: left;
          height: 20px;
          font-size: 14px;
          font-weight: bold;
          color: #00a0d9;
          line-height: 20px;
        }
        .device-state {
          .point {
            width: 10px;
            height: 10px;
            display: inline-block;
            margin-right: 8px;
            border-radius: 50%;

            // &.icon-machine-offline,

            &.blue {
              background-color: $--color-primary;
            }

            &.red {
              background-color: $--color-danger;
            }
            &.yellow {
              background-color: $--color-warning;
            }
            &.gray {
              background-color: $--color-info;
            }
            &.green {
              background-color: $--color-success;
            }
          }
          .state-name {
            height: 20px;
            font-size: 12px;
            font-weight: bold;
            color: #202945;
            line-height: 20px;

          }
        }
      }

      .device-img {
        &.gray {
          background: #f5f5f5;
        }
        $r: 150px;
        width: $r;
        height: $r;
        margin: 24px auto;
        position: relative;

        &.offline {
          /** 图片去色 */
          -webkit-filter: grayscale(100%);
          -moz-filter: grayscale(100%);
          -ms-filter: grayscale(100%);
          -o-filter: grayscale(100%);
          filter: grayscale(100%);
          filter: gray;
        }

        > img {
          position: absolute;
          max-width: 100%;
          max-height: 100%;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .body-num {
        height: 25px;
        font-size: 18px;
        font-weight: bold;
        color: #202945;
        line-height: 25px;
        text-align: center;
        margin: 24px auto;
      }
      .device-status-container {
        font-size: 0;
        margin-right: 22px;
        border: 1px solid;
        border-image: linear-gradient(
            90deg,
            rgba(0, 159.99997526407242, 217.0000022649765, 0),
            rgba(0, 160.00000566244125, 217.0000022649765, 0.1599999964237213),
            rgba(0, 159.99997526407242, 217.0000022649765, 0)
          )
          1 1;
        padding: 24px 0;
        display: flex;
        justify-content: center;
        width: 100%;
        .device-status {
          font-size: 12px;
          color: #4d4d4d;
          // margin-top: 24px;
          overflow: hidden;
          display: inline-block;

          > li {
            float: left;
            height: 22px;
            &:nth-child(n + 2) {
              margin-left: 10px;
            }
            &.signal {
              .val {
                padding-left: 2px;
              }
            }
            .key {
              float: left;
              color: #00a0d9;
              .icon {
                float: left;
                font-size: 18px;
                line-height: 22px;
              }
            }
            .val {
              float: left;
              margin-left: 2px;
              line-height: 22px;
            }

            .icon-wifi-i,
            .icon-signal-i {
              float: left;
              // display: inline-block;
              height: 18px;
              width: 18px;
              margin-top: 2px;
              line-height: 22px;
              background-repeat: no-repeat;
              background-position: center;
              background-size: 100%;
            }
            .signal-xinhao100 {
              background-image: url('~@/images/layout/icon-signal-100.svg');
            }
            .signal-xinhao75 {
              background-image: url('~@/images/layout/icon-signal-75.svg');
            }
            .signal-xinhao50 {
              background-image: url('~@/images/layout/icon-signal-50.svg');
            }
            .signal-xinhao25 {
              background-image: url('~@/images/layout/icon-signal-25.svg');
            }
            .wifi100 {
              background-image: url('~@/images/layout/icon-wifi-100.svg');
            }
            .wifi66 {
              background-image: url('~@/images/layout/icon-wifi-66.svg');
            }
            .wifi33 {
              background-image: url('~@/images/layout/icon-wifi-33.svg');
            }
          }
        }
        .device-state {
          margin-left: 22px;
          .device-state-tag {
            $r: 22px;
            // width: $r;
            // height: $r;
            border-radius: $r / 2;
            // background: rgba(13, 154, 224, 0.05);
            overflow: hidden;
            float: left;
            &.has-name {
              // width: auto;
              // padding-right: 10px;
              line-height: $r;
              .icon {
                // margin-left: 9px;

                &.icon-cleaning,
                &.icon-free {
                  font-size: 18px;
                }

                &.icon-cleaning {
                  margin-top: 5px;
                }
                &.icon-suspend,
                &.icon-free,
                &.icon-charge {
                  margin-top: 4px;
                }

                &.icon-machine-offline {
                  margin-top: 5px;
                  font-size: 18px;
                }
              }
            }
            &:nth-child(n + 2) {
              margin-left: 6px;
            }

            .icon {
              $r: 18px;
              width: $r;
              height: $r;
              text-align: center;
              line-height: $r;
              float: left;
              margin-top: 3px;
              margin-left: 3px;
              font-size: 18px;

              // &.icon-machine-offline,

              &.blue {
                color: $--color-primary;
              }

              &.red {
                color: $--color-danger;
              }
              &.yellow {
                color: $--color-warning;
              }
              &.gray {
                color: $--color-info;
              }
              &.green {
                color: $--color-success;
              }
            }

            .state-name {
              float: left;
              font-size: 12px;
              color: #495057;
              margin-left: 3px;
            }
          }
        }
      }

      .param-detail {
        margin-top: 24px;
        color: #6c757d;
        font-size: 12px;
        > li {
          padding: 10px 0;
          border-bottom: 1px solid #eef2f7;
          display: flex;
          align-items: center;
          &:last-child {
            border-bottom: none;
          }
          .content {
            flex: 1;
            overflow: hidden;
            .key {
              height: 18px;
              font-size: 12px;
              font-weight: bold;
              color: $--color-text-secondary;
              line-height: 18px;
            }
            .val {
              margin-top: 4px;
              // height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: $--color-text-regular;
              line-height: 20px;
              margin-right: 20px;
            }
          }
          .icon {
            font-size: 14px;
            color: $--color-primary;
            cursor: pointer;
          }
          .adress {
            margin-top: 6px;
            color: #98a6ad;
            line-height: 17px;
          }
        }
      }
    }

    .tap-content {
      overflow: hidden;
      // &.mapbox {
      //   height: calc(100% - 84px);
      //   min-height: 789px;
      //   position: absolute;
      //   top: 68px;
      //   left: 332px;
      //   right: 16px;
      // }
    }
  }
}
</style>
